import { render, staticRenderFns } from "./PointRecord.vue?vue&type=template&id=3fc26f3a&scoped=true"
import script from "./PointRecord.vue?vue&type=script&lang=js"
export * from "./PointRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc26f3a",
  null
  
)

export default component.exports